<div class="flex flex-col max-w-screen-xl mx-auto xl:p-10 md:p-8 justify-center items-center bg-card">

    <div > PROVA BACKEND </div>

    <div class="flex flex-col min-h-200 h-auto w-full">

        <div *ngFor="let step of field.fieldGroup; let index = index; let last = last">
            <formly-field [field]="step"></formly-field>
        </div>

    </div>
</div>










